import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Pagination} from "antd";
import $Jq from "jquery";

/**
 * creat by tianruojun
 * @description 分页器模板
 * @class PaginationTemplate
 * @extends {Component}
 */
export default class PaginationTemplate extends Component {
    static propTypes = {
        /**
         * @text 数据总数
         * @category data
         */
        total: PropTypes.number,
        /**
         * @text 页容量
         * @category data
         */
        pageSize: PropTypes.number,
        /**
         * @text 当前页码
         * @category data
         */
        current: PropTypes.number,
        /**
         * @text 点页容量改变回调
         * @category event
         */
        onShowSizeChange: PropTypes.func,
        /**
         * @text 页码改变回调
         * @category event
         */
        onChange: PropTypes.func,
    };
    static defaultProps = {
        total: 0,
        pageSize: 10,
        current: 1,
        showHeight: true,
        onShowSizeChange: (dept, call) => {
            console.log("点页容量改变回调========", dept);
        },
        onChange: (dept, call) => {
            console.log("页码改变回调========", dept);
        },
    };

    /**
     * 处理睡觉的回调
     * @param {string} name 姓名
     */
    onSleep = (name) => {
        this.setState({name})
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
        const observer = new ResizeObserver(e=>{
            e.forEach(entry=>{
                this.props.onResize(entry.target.offsetHeight);
            });
        });
        const target = document.querySelector('.PaginationTemplate');
        target&&observer.observe(target)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        $Jq('.ant-pagination-options-quick-jumper').find("input").val("");
    }

    render() {
        const {total,onShowSizeChange,pageSize,current,onChange,config={},showHeight} = this.props;
        if(current>1 && (current-1)*pageSize >= total) {
            onChange({current:current-1,pageSize})
        }
        let size = config?.size || "";
        let pageSizeOptions = config?.pageSizeOptions || ['10', '20', '30', '40'];
        return (
            <div className={'PaginationTemplate'} style={{display: 'flex', justifyContent: 'right', padding: '10px 32px',borderTop: "1px solid #e8e8e8",height:showHeight ? 72 : "auto",margin:"0px -32px"}}>
                <Pagination
                    size={size}
                    // 是否可以改变 pageSize
                    showSizeChanger
                    // 是否可以快速跳转至某页
                    showQuickJumper
                    // pageSize 变化的回调
                    onShowSizeChange={(current, size)=>{onShowSizeChange({current,pageSize:size})}}
                    onChange={(page, pageSize)=>{onChange({current:page,pageSize})}}
                    // 当前页数
                    current={current}
                    // 禁用分页
                    disabled={false}
                    // 默认的当前页数
                    defaultCurrent={1}
                    // 默认的每页条数
                    defaultPageSize={10}
                    // 只有一页时是否隐藏分页器
                    hideOnSinglePage={false}
                    // 指定每页可以显示多少条
                    pageSizeOptions={pageSizeOptions}
                    // 每页条数
                    pageSize={pageSize}
                    // 数据总数
                    total={total}
                    // 用于显示数据总量和当前数据顺序
                    showTotal={(total) => `共 ${total} 条`}

                />
            </div>
        )
    }

}